import { HttpApi, OpenApi } from "effect/http-api";
import { withoutNullQueryParameters } from "./openapi-query.js";
import { SixSenseV3Group } from "./6sense/index.js";
import { AnnualReportsV3Group } from "./annual-report/index.js";
import { AssetsV3Group } from "./assets/index.js";
import { Authorization } from "./authorization.middleware.js";
import { ClientsV3Group } from "./clients/index.js";
import { CareersV3Group } from "./careers/index.js";
import { CompaniesV3Group } from "./companies/index.js";
import { CompanyVerticalsV3Group } from "./company-vertical/index.js";
import { FiltersV3Group } from "./filters/index.js";
import { LocationIntelligenceV3Group } from "./location-intelligence/index.js";
import { PlutoV3Group } from "./pluto/index.js";
import { PrvTrademarksGroup } from "./prv/index.js";
import { SourceHealthV3Group } from "./source-health/index.js";
import {
  PublicAuthGroup,
  PublicClientTagsGroup,
  PublicCompaniesGroup,
  PublicCompanyDetailsGroup,
  PublicHeatFilterAuthoringGroup,
  PublicFiltersGroup,
  PublicHealthGroup,
} from "./public/index.js";

export const V3Api = HttpApi.make("v3")
  .add(ClientsV3Group.middleware(Authorization))
  .add(CareersV3Group.middleware(Authorization))
  .add(CompanyVerticalsV3Group.middleware(Authorization))
  .add(FiltersV3Group.middleware(Authorization))
  .add(PrvTrademarksGroup.middleware(Authorization))
  .add(SixSenseV3Group.middleware(Authorization))
  .add(AnnualReportsV3Group.middleware(Authorization))
  .add(AssetsV3Group.middleware(Authorization))
  .add(CompaniesV3Group.middleware(Authorization))
  .add(LocationIntelligenceV3Group.middleware(Authorization))
  .add(PlutoV3Group.middleware(Authorization))
  .add(SourceHealthV3Group.middleware(Authorization))
  .add(PublicHealthGroup)
  .add(PublicAuthGroup)
  .add(PublicHeatFilterAuthoringGroup.middleware(Authorization))
  .add(PublicFiltersGroup.middleware(Authorization))
  .add(PublicClientTagsGroup.middleware(Authorization))
  .add(PublicCompaniesGroup)
  .add(PublicCompanyDetailsGroup)
  .prefix("/v3")
  .annotate(OpenApi.Transform, withoutNullQueryParameters);

export * from "./authorization.middleware.js";
export * from "./clients/index.js";
export * from "./careers/index.js";
export * from "./companies/index.js";
export * from "./filters/index.js";
export * from "./location-intelligence/index.js";
export * from "./prv/index.js";
export * from "./annual-report/index.js";
export * from "./assets/index.js";
export * from "./pluto/index.js";
export * from "./source-health/index.js";
export * from "./public/index.js";
export * from "./json-unknown.js";
